module.exports = __webpack_public_path__ + "6f2996e9f44e061c43353d4cfc44dae9.ttf";